export default function VideoModal() {
	let videoImage = $('.videoModal');

	if (videoImage.length > 0) {
		function getVideoModal() {
			let videoImage = $('.videoModal');
			videoImage.click(function () {
				let imageDataId = $(this).attr('data-id');
				let modalWindow = $('.videoText__modal[data-id=' + imageDataId + ']');
				modalWindow.css('display', 'block');
			});
		}
		getVideoModal();

		$(window).on('resize', function () {
			getVideoModal();
		});

		let close = $('.videoText__close');
		let videoWrap = $('.videoText__modalWrap');

		function closeModal(elem) {
			elem.on('click', () => {
				var videos = document.querySelectorAll('iframe, video');
				Array.prototype.forEach.call(videos, function (video) {
					if (video.tagName.toLowerCase() === 'video') {
						video.pause();
					} else {
						var src = video.src;
						video.src = src;
					}
				});

				$('.videoText__modal').css('display', 'none');
			});
		}
		closeModal(close);
		closeModal(videoWrap);
	}
}
